import React from 'react';
import { inject, observer } from 'mobx-react';
import { Spring, animated } from 'react-spring';

import { formatCurrency } from 'js/services/Format';
import Container from './Container';
import Label from './Label';
import Value from './Value';
import Row from './Row';
import Money from './Money';

import Buttons from './Buttons';
import ManageButton from './ManageButton';
import ImageUploader from 'js/components/core/ImageUploader';

export default inject('page')(
  observer(({ page }) => {
    const {
      alias,
      seller,
      title,
      actual_price,
      is_buyer,
      toggleManageMenu,
      can_modify,
      primary_image,
      setError,
      order_shipping,
      has_order,
      onUpload,
      order_uid,
    } = page;

    return (
      <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {animation => (
          <animated.div style={animation}>
            <Container>
              {can_modify && (
                <Buttons>
                  <ManageButton onClick={toggleManageMenu} />
                </Buttons>
              )}

              {has_order && (
                <Row>
                  <Label>ORDER ID</Label>
                  <Value>{order_uid}</Value>
                </Row>
              )}

              {is_buyer && (
                <Row>
                  <Label>SELLER</Label>
                  <Value>@{seller}</Value>
                </Row>
              )}

              <Row>
                <Label>ITEM</Label>
                <Value>{title}</Value>
              </Row>

              <Row>
                <Label>PRICE</Label>
                <Value>
                  <Money>{formatCurrency(actual_price)}</Money>
                </Value>
              </Row>

              <Row>
                <Label>SHIPPING</Label>
                <Value>{is_buyer ? order_shipping : 'covered by buyer'}</Value>
              </Row>

              {primary_image && !primary_image.match(/missing-image/) && (
                <Row spacing="1rem">
                  <Label>PICTURE</Label>
                  <Value>
                    <ImageUploader
                      disabled={has_order}
                      image={primary_image}
                      alias={alias}
                      setError={setError}
                      onUpload={onUpload}
                      applyChange
                      size="5rem"
                    />
                  </Value>
                </Row>
              )}
            </Container>
          </animated.div>
        )}
      </Spring>
    );
  }),
);
